// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var $        = require('./$')
  , $export  = require('./$.export')
  , anObject = require('./$.an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey){
    return $.getDesc(anObject(target), propertyKey);
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/babel-core/~/core-js/modules/es6.reflect.get-own-property-descriptor.js
// module id = 148
// module chunks = 0